export const SET_PAYERS_FILTERS = 'SET_PAYERS_FILTERS';

export const RESET_PAYERS_FILTERS = 'RESET_PAYERS_FILTERS';

export const SET_PAYERS_GRID_SORT_CRITERIA = 'SET_PAYERS_GRID_SORT_CRITERIA';
